<template>
  <vs-popup class="add-additional-cost-popup" id="popup" :title="`PRODUCT ORDER ITEM CHANGE REQUESTS`"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>
      <vs-table :data="request_list" id="popup" class="table-dark-inverted table-auto vs-con-loading__container">

        <template slot="thead">
          <vs-th>DATE/TIME</vs-th>
          <vs-th width="15%">REQUEST TYPE</vs-th>
          <vs-th>REQUEST STATUS</vs-th>
          <vs-th>MODERATED BY</vs-th>
          <vs-th width="20%">DATA</vs-th>
          <vs-th width="20%">COMMENT</vs-th>
          <vs-th width="10%">ACTION</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :state="indextr == 0 ? 'primary' : ''" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].created_at">
              {{ __dateTimeFormatter(data[indextr].created_at) }}
            </vs-td>

            <vs-td :data="data[indextr].type" class="font-bold">
              {{ data[indextr].type === 'Cancel' ? 'cancel order' : 'change order quantity' }}
            </vs-td>

            <vs-td :data="data[indextr].status">
              <vs-chip style="border-radius: 0;"
                :color="tr.status === 'Accepted' ? 'primary' : (tr.status === 'Rejected' ? 'danger' : '')">
                {{ data[indextr].status }}
              </vs-chip>
            </vs-td>
            <vs-td>
              {{ data[indextr].moderated_by.name || 'N/A' }}
            </vs-td>
            <vs-td :data="data[indextr].data">
              <span v-if="data[indextr].type === 'Change'">
                From : <span class="font-bold">{{ data[indextr].data.from }} KG</span>
                To : <span class="font-bold">{{ data[indextr].data.to }} KG</span>
              </span>
              <span v-else>N/A</span>
            </vs-td>

            <vs-td :data="data[indextr].comment">
              {{ data[indextr].comment }}
            </vs-td>

            <vs-td>
              <div class="vx-row" v-if="data[indextr].status === 'Pending' && indextr == 0">
                <vx-tooltip class="flex justify-start mr-2" text="Accept Request" position="top">
                  <vs-button class="flex justify-end"
                    @click.stop="onClickStatusChange(data[indextr].id, 'accept', data[indextr].type)" size="small"
                    color="primary" type="filled" icon-pack="feather" icon="icon-check"></vs-button>
                </vx-tooltip>
                <vx-tooltip class="flex justify-start mr-2" text="Reject Request" position="top">
                  <vs-button class="flex justify-end"
                    @click.stop="onClickStatusChange(data[indextr].id, 'reject', data[indextr].type)" size="small"
                    color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
                </vx-tooltip>
              </div>
            </vs-td>

          </vs-tr>
        </template>

      </vs-table>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
const CustomerRepository = RepositoryFactory.get('customer')
import Calculations from '@/mixins/Calculations'

function initialState() {
  return {
    open: false,
    id: '',
    activities: [],
    request_list: [],
    formulation_id: '',
    customer_id: '',
    account_currency: 'GBP'
  }
}

export default {
  name: 'ViewProductOrderItemChangeRequestsPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(request_list, formulation_id, customer_id, account_currency) {
      try {
        Object.assign(this.$data, initialState())
        this.request_list = request_list
        this.formulation_id = formulation_id
        this.customer_id = customer_id
        this.account_currency = account_currency
        this.open = true;
      } catch (error) {

      }
    },
    async onClickStatusChange(id, status, type) {
      try {
        if (type === 'Change' && status === 'accept') {
          this.acceptChangeRequest(id, status)
        } else {
          await CustomerRepository.productOrderItemChangeRequestStatusChange(id, status)
          this.$emit('refreshItems')
          this.open = false
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async acceptChangeRequest(request_id, status) {
      try {
        const payload = {
          customer_id: this.customer_id,
          formulation_ids: [this.formulation_id]
        }
        const { data } = (await CustomerRepository.getListOfCartProductCatalogue(payload, 0)).data
        const catalog = data.find((x) => x.id === this.formulation_id)

        const request = this.request_list.find((x) => x.id === request_id)

        let price = 0
        if (catalog.type === 'List') {
          price = this.calculateProductListPrice(catalog.pe_g, request.data.to)
        }
        if (catalog.type === 'Bespoke') {
          price = this.bespokeAndContractPriceCalculator(catalog.price, request.data.to, catalog.fx_rate)
        }
        if (catalog.type === 'Contract' && !!catalog.contract_price && catalog.contract_price.constructor === Array) {
          price = this.bespokeAndContractPriceCalculator(catalog.contract_price, request.data.to)
        }
        this.open = false
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: `Confirm Quantity Change`,
          text: `For ${request.data.to}KG price will be ${price} ${this.account_currency}. Are you sure you want to make this change?`,
          accept: this.acceptPriceQuantity,
          cancel: this.cancelPriceQuantity ,
          parameters: [request_id, status, request.data.to, price]
        })

      } catch (error) {
        this.convertAndNotifyError(e)
      }
    },
    cancelPriceQuantity() {
      this.open = true
    },
    async acceptPriceQuantity(params) {
      try {
        await CustomerRepository.productOrderItemChangeRequestStatusChange(params[0], params[1], { quantity: params[2], price: params[3] })
        this.$emit('refreshItems')
        this.open = false
      } catch (error) {
        this.convertAndNotifyError(e)
      }
    }

  },
  mixins: [SuccessMessage, ErrorMessages, Calculations],
}
</script>

<style scoped>
.add-additional-cost-popup>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 90% !important;
}
</style>
